import React, { Component } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from '../../../button/ButtonComponent';
import { PAYMENT_THRESHOLD } from '../../../../constants';
import { PAYMENT_DELAY } from '../../../../constants/payment';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import {
    getPaidAmountFormatted,
    isCurrentOnGoingPayementRequest,
    getDateFormatted,
    isFetching
} from '../../../../services/account/paymentrequest/ongoing/selector';
import { InfoAccountComponent } from '../InfoAccountComponent';
import { withLoadingCondition } from '../../../loading/withLoadingCondition';
import PaymentRequestFormComponent from './PaymentRequestFormComponent';

import { ThresholdReachMessageParagraph } from './PaymentAreaComponentStyle';
import { getI18nByApp } from '../../../../services/i18n/selector';

class PaymentAreaComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { showFormPaymentRequest: false };
    }

    renderGetCashbackButton = () => {
        const { isCurrentOnGoingPayementRequest, thresholdReached, i18n } = this.props;

        if (!isCurrentOnGoingPayementRequest) {
            return (
                <div className="buttonWrapper">
                    {thresholdReached && (
                        <ThresholdReachMessageParagraph>
                            {convertHtmlToReactDomWithParams(
                                getI18nByApp(
                                    i18n,
                                    'page.ACCOUNT.CASHBACK_JACKPOT.TRESHOLD_REACHED_PAYMENT_METHOD_SELECT'
                                ),
                                PAYMENT_THRESHOLD
                            )}
                        </ThresholdReachMessageParagraph>
                    )}

                    <ButtonComponent
                        color="main"
                        disabled={!thresholdReached}
                        text={getI18nByApp(
                            i18n,
                            'page.ACCOUNT.CASHBACK_JACKPOT.BUTTON_GET_GAIN_EBON'
                        )}
                        onClick={this.handleActiveButtonClick}
                    />

                    {!thresholdReached && (
                        <p>
                            {getI18nByApp(i18n, 'page.ACCOUNT.CASHBACK_JACKPOT.TRESHOLD_MESSAGE')}{' '}
                            {PAYMENT_THRESHOLD}€.
                        </p>
                    )}
                </div>
            );
        }
        return null;
    };

    renderCurrentPayment = () => {
        const {
            i18n,
            isCurrentOnGoingPayementRequest,
            paidAmountOnGoingPayementRequest,
            dateOnGoingPaymentRequest
        } = this.props;

        if (isCurrentOnGoingPayementRequest) {
            return (
                <div className="txtleft">
                    <h3>{getI18nByApp(i18n, 'page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_AREA')}</h3>
                    <InfoAccountComponent>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_ONGOING_1'),
                            paidAmountOnGoingPayementRequest,
                            `<span class="bold">${dateOnGoingPaymentRequest}</span>`
                        )}
                        <br />
                        {getI18nByApp(i18n, 'page.ACCOUNT.CASHBACK_JACKPOT.PAYMENT_ONGOING_2')}
                    </InfoAccountComponent>
                </div>
            );
        }
        return null;
    };

    handleActiveButtonClick = () => {
        this.setState({
            showFormPaymentRequest: !this.state.showFormPaymentRequest
        });
    };

    renderPaymentRequestFormComponent = () =>
        this.state.showFormPaymentRequest &&
        !this.props.isCurrentOnGoingPayementRequest && <PaymentRequestFormComponent />;

    renderArea = () => (
        <div className="txtcenter-mob bt-recup-cagnotte">
            {this.renderCurrentPayment()}
            {this.renderGetCashbackButton()}
            {this.renderPaymentRequestFormComponent()}
        </div>
    );

    render() {
        return (
            <div id="paymentAreaAnchor">
                {withLoadingCondition(this.props.isFetchingOnGoingPayment, this.renderArea)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        paidAmountOnGoingPayementRequest: getPaidAmountFormatted(state),
        isCurrentOnGoingPayementRequest: isCurrentOnGoingPayementRequest(state),
        dateOnGoingPaymentRequest: getDateFormatted(state, PAYMENT_DELAY),
        isFetchingOnGoingPayment: isFetching(state)
    };
};

export default connect(mapStateToProps)(PaymentAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponent.js